import { render, staticRenderFns } from "./ApplicationWrapWithoutHeader.vue?vue&type=template&id=26540d22"
import script from "./ApplicationWrapWithoutHeader.vue?vue&type=script&lang=js"
export * from "./ApplicationWrapWithoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports